import Init from "../../../../init/init";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CurtomerTimeManager extends cc.Component {

    

    timeNow:number=0
    day:number=0
    year:number=0
    month:number=0
    todayListTimeArr:number[]=[]
    intervalTime=300000

    Init()
    {
        this.timeNow=Date.now()
        let date = new Date(this.timeNow);
        this.day=date.getDay()
        this.month=date.getMonth()
        this.year=date.getFullYear()
    }
    start () {

    }
    
    showSingleTime(time:number)
    {
       
        if(this.todayListTimeArr.length>0)
        {
            let lastTime=this.todayListTimeArr[this.todayListTimeArr.length-1]
            if(time-lastTime>this.intervalTime)
            {
                return this.addNewTodayTime(time)
            }
            {
                return ""
            }
        }
        return this.addNewTodayTime(time)
    }
    addNewTodayTime(time)
    {
        let date = new Date(time);
        this.todayListTimeArr.push(time)
        this.todayListTimeArr=this.todayListTimeArr.sort(function (a, b) {
            return a - b;
          });
        return date.format('hh:mm');
    }
    

    checkHistoryListTime(list:any[])
    {
        list=list.sort(function(a,b){
            return Number(a.createTime)-Number(b.createTime)
        })
        for(let i=0;i<list.length;i++)
        {
            let data=list[i]
            let dateTime=new Date(list[i].createTime);
            let lastTime=0
            if(i==0)//获取聊天记录列表第一条记录一定给时间
            {
                lastTime=Number(list[i].createTime)
                if(dateTime.getFullYear()==this.year && dateTime.getMonth()==this.month && dateTime.getDay()==this.day)//如果是当天的记录
                {
                    list[i].createTime=dateTime.format('hh:mm');
                }
                else //如果不是当天聊天记录
                {
                    list[i].createTime=dateTime.format('dd/MM/yyyy hh:mm');
                }
                
            }
            else 
            {
                let newTime=Number(list[i].createTime)
                if(dateTime.getFullYear()==this.year && dateTime.getMonth()==this.month && dateTime.getDay()==this.day)
                {
                    if(newTime-lastTime>this.intervalTime)
                    {
                        lastTime=newTime
                        list[i].createTime=dateTime.format('hh:mm');
                    }
                    else
                    {
                        list[i].createTime=""
                    }
                }
                else
                {
                    if(newTime-lastTime>this.intervalTime)
                    {
                        lastTime=newTime
                        list[i].createTime=dateTime.format('dd/MM/yyyy hh:mm:ss');
                    }
                    else
                    {
                        list[i].createTime=""
                    }  
                }
            }
        }
        return list
    }
    // update (dt) {}
}
